import style from "./index.module.scss";
export default function index(){
    return (
        <div className={style.index}>《中华人民共和国工业和信息化部》粤ICP备2025370112号</div>
    )
}
